const WhyDarija = () => {
  const reasons = [
    {
      icon: 'fas fa-brain',
      color: 'from-blue-500 to-indigo-600',
      title: 'فهم أسرع وأعمق',
      desc: 'الدماغ يفهم أسرع كي تقرا بلغتك - الدارجة تخليك تركز على المعلومة بلاصة ما تتعب في ترجمة الكلمات'
    },
    {
      icon: 'fas fa-heart',
      color: 'from-red-500 to-pink-500',
      title: 'راحة نفسية',
      desc: 'كي تقرا بلغتك تحس براحة وثقة - ما تحسش روحك غريب ولا تخاف تسقسي'
    },
    {
      icon: 'fas fa-comments',
      color: 'from-green-500 to-emerald-600',
      title: 'أمثلة من حياتك',
      desc: 'نستعملو أمثلة من الحياة اليومية تاع الجزائر - كلشي مفهوم وقريب ليك'
    },
    {
      icon: 'fas fa-graduation-cap',
      color: 'from-purple-500 to-pink-600',
      title: 'للكل',
      desc: 'حتى إذا ما تعرفش الفرنسية ولا الإنجليزية مليح، تقدر تتعلم بلا مشاكل'
    }
  ];

  return (
    <section className="relative z-10 py-24 bg-gradient-to-b from-white to-gray-50 overflow-x-hidden">
      {/* Background decoration */}
      <div className="absolute top-20 left-0 w-40 h-40 md:w-56 md:h-56 lg:w-72 lg:h-72 bg-primary/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-0 w-40 h-40 md:w-56 md:h-56 lg:w-72 lg:h-72 bg-secondary/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-[1200px] mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 text-primary rounded-full mb-6 font-semibold text-sm">
              <i className="fas fa-lightbulb"></i>
              <span>لماذا الدارجة؟</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-text mb-6 leading-tight">
              علاش التعلم <span className="text-primary">بالدارجة الجزائرية</span>؟
            </h2>
            <p className="text-xl md:text-2xl text-text2 leading-relaxed max-w-[900px] mx-auto">
              التعليم بلغتك الأم هو المفتاح للفهم الصحيح والتعلم السريع
            </p>
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            {/* Left side - Comparison: With Darija vs Without */}
            <div className="relative">
              <div className="bg-white rounded-3xl p-8 shadow-2xl border-2 border-gray-100">
                <h3 className="text-2xl font-black text-center text-text mb-6">شوف الفرق!</h3>
                
                {/* Comparison Grid */}
                <div className="space-y-4">
                  {/* WITHOUT Darija - Confusing */}
                  <div className="p-5 bg-red-50 rounded-2xl border-2 border-red-200">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center text-white">
                        <i className="fas fa-times"></i>
                      </div>
                      <span className="font-black text-red-700">بالعربية الفصحى</span>
                    </div>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      "ينبغي عليك أن تمارس الكفاءات والمهارات اللغوية بصفة دورية ومنتظمة ومتواصلة من أجل تحقيق مستوى الإتقان والطلاقة التامة المطلوبة في اللغة المستهدفة"
                    </p>
                    <div className="mt-3 flex items-center gap-2 text-red-600 text-xs font-bold">
                      <i className="fas fa-dizzy"></i>
                      <span>معقد جداً، ما فهمتش والو!</span>
                    </div>
                  </div>

                  {/* Arrow pointing down */}
                  <div className="text-center py-2">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-primary to-secondary text-white rounded-full font-bold text-sm">
                      <i className="fas fa-exchange-alt"></i>
                      <span>نفس المعنى بالدارجة</span>
                    </div>
                  </div>

                  {/* WITH Darija - Easy */}
                  <div className="p-5 bg-green-50 rounded-2xl border-2 border-green-200">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center text-white">
                        <i className="fas fa-check"></i>
                      </div>
                      <span className="font-black text-green-700">بالدارجة الجزائرية</span>
                    </div>
                    <p className="text-gray-700 text-base leading-relaxed font-semibold">
                      "لازم عليك تمارس مهارات اللغة كل يوم وبشكل منتظم ومستمر باش توصل للإتقان والطلاقة الكاملة في اللغة اللي راك تتعلمها"
                    </p>
                    <div className="mt-3 flex items-center gap-2 text-green-600 text-xs font-bold">
                      <i className="fas fa-smile-beam"></i>
                      <span>كلمات بسيطة وواضحة!</span>
                    </div>
                  </div>
                </div>

                {/* Bottom Result */}
                <div className="mt-6 p-4 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-2xl text-center">
                  <div className="flex items-center justify-center gap-2 text-primary">
                    <i className="fas fa-bolt text-2xl"></i>
                    <span className="font-black text-lg">تعلم أسرع بـ 3 مرات!</span>
                  </div>
                </div>
              </div>

              {/* Floating badge */}
              <div className="absolute -top-4 -right-4 bg-accent text-white px-6 py-3 rounded-2xl shadow-xl font-bold rotate-6">
                <div className="flex items-center gap-2">
                  <i className="fas fa-star"></i>
                  <span>100% بالدارجة</span>
                </div>
              </div>
            </div>

            {/* Right side - Reasons */}
            <div className="space-y-6">
              {reasons.map((reason, index) => (
                <div
                  key={index}
                  className="group bg-white rounded-2xl p-6 shadow-lg border-2 border-gray-100 hover:border-primary/30 transition-all duration-300 hover:-translate-x-2"
                >
                  <div className="flex items-start gap-5">
                    <div className={`w-14 h-14 bg-gradient-to-br ${reason.color} rounded-xl flex items-center justify-center text-white text-xl flex-shrink-0 shadow-lg transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6`}>
                      <i className={reason.icon}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl md:text-2xl font-black text-text mb-2">
                        {reason.title}
                      </h3>
                      <p className="text-lg text-text2 leading-relaxed">
                        {reason.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Bottom CTA */}
          <div className="bg-gradient-to-br from-primary via-primary-dark to-secondary rounded-3xl p-10 md:p-12 shadow-2xl text-white relative overflow-hidden">
            {/* Background pattern */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute inset-0" style={{
                backgroundImage: `radial-gradient(circle at 20% 30%, rgba(255,255,255,0.3) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(255,255,255,0.2) 0%, transparent 50%)`
              }}></div>
            </div>

            <div className="relative z-10 text-center">
              <h3 className="text-3xl md:text-4xl font-black mb-4">
                جرب التعلم بالدارجة درك!
              </h3>
              <p className="text-xl md:text-2xl text-white/95 mb-8">
                اكتشف الفرق بنفسك - شوف كيفاش التعلم بالدارجة أسهل
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="/courses"
                  className="inline-flex items-center justify-center gap-2 px-10 py-5 bg-white text-primary font-black rounded-2xl hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1 text-lg"
                >
                  <span>شوف الدورات</span>
                  <i className="fas fa-arrow-left"></i>
                </a>
                <a
                  href="/register"
                  className="inline-flex items-center justify-center gap-2 px-10 py-5 bg-white/10 backdrop-blur-sm text-white font-bold rounded-2xl border-2 border-white hover:bg-white/20 transition-all text-lg"
                >
                  <i className="fas fa-user-plus"></i>
                  <span>سجل درك</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyDarija;
